/** The `views` area: the Views page. Owned by the stage 2 slot views
 *  (docs/I18N.md §11). */
export const views = {
  'views.page.title': 'Boards',
  'views.page.subEmpty': 'shared places for work',
  'views.page.saved': '{count} saved',
  'views.page.favorites': 'Favorites',
  'views.page.all': 'All boards',
  'views.page.archived': 'Archived',
  /** The empty overview: the one sentence of the kind. */
  'views.page.empty': 'A board is a shared place for work. Everyone on it sees the same items.',
  /** A board card's meta line, after the layout: the principal whose home it is. */
  // --- The Browse footer: the rest of the nav ----------------------------------
  'views.browse.title': 'Browse',
  'views.browse.lenses': 'Views',
  'views.browse.boards': 'Boards',
  'views.browse.groups': 'Groups',
  'views.browse.flowPhases': 'Stages',
  'views.browse.flows': 'Flows',
  'views.browse.plans': 'Plans',
  'views.browse.ceremonies': 'Ceremonies',
} as const;
